import { Box } from '@mui/material';
import { useLayoutEffect, useMemo, useRef } from 'react';
import DigitalAssistentSummary from './DigitalAssistentSummary';
import { useChatContext } from '../../../../../contexts/ChatContext';
import ChatMessage from './ChatMessage';
import ChatMessageLoader from './ChatMessageLoader';
import PersistentChatContainer from './PersistentChatContainer';

const ChatBody = (): JSX.Element => {
  const { selectedChat, chatMessages, isTyping } = useChatContext();
  const chatBodyRef = useRef<HTMLDivElement | null>(null);
  const lastChatMessageCount = useRef<{ [chatId: string]: number }>({});
  const filteredChatMessages = useMemo(
    () => chatMessages.filter(message => message.ContactId === selectedChat),
    [chatMessages, selectedChat]
  );

  useLayoutEffect(() => {
    if (!selectedChat) return;

    const currentLength = filteredChatMessages.length;
    const previousLength = lastChatMessageCount.current[selectedChat] || 0;

    if (currentLength > previousLength) {
      chatBodyRef.current?.scrollTo({
        top: chatBodyRef.current.scrollHeight
      });
    }

    lastChatMessageCount.current[selectedChat] = currentLength;
  }, [filteredChatMessages, selectedChat]);

  return (
    <Box
      sx={{
        overflow: 'auto',
        height: '100%',
        position: 'relative'
      }}
      data-testid="chat-body"
      ref={chatBodyRef}
    >
      <Box sx={{ overflow: 'auto', padding: '15px' }}>
        <PersistentChatContainer />
        <DigitalAssistentSummary />

        {filteredChatMessages.map((item, index) => (
          <ChatMessage key={index} chatMessage={item} />
        ))}

        {isTyping.map(
          typingEvent =>
            typingEvent.contactId === selectedChat &&
            typingEvent.isTyping && <ChatMessageLoader key={typingEvent.contactId} />
        )}
      </Box>
    </Box>
  );
};

export default ChatBody;
